export const PATIENT_GENDER_LABELS: Record<Patients.PatientGender, string> = {
	MALE: 'Masculino',
	FEMALE: 'Feminino',
	OTHER: 'Outro',
	PREFER_NOT_TO_SAY: 'Prefiro não informar',
};

export const PATIENT_MARITAL_STATUS_LABELS: Record<
	Patients.PatientMaritalStatus,
	string
> = {
	SINGLE: 'Solteiro(a)',
	MARRIED: 'Casado(a)',
	DIVORCED: 'Divorciado(a)',
	WIDOWED: 'Viúvo(a)',
	SEPARATED: 'Separado(a)',
	STABLE_UNION: 'União estável',
};

export const PATIENT_EDUCATION_LEVEL_LABELS: Record<
	Patients.PatientEducationLevel,
	string
> = {
	NONE: 'Nenhum',
	ELEMENTARY: 'Ensino fundamental',
	HIGH_SCHOOL: 'Ensino médio',
	TECHNICAL: 'Técnico',
	UNDERGRADUATE: 'Graduação',
	POSTGRADUATE: 'Pós-graduação',
	DOCTORATE: 'Doutorado',
};

export const PATIENT_GENDER_OPTIONS = Object.entries(
	PATIENT_GENDER_LABELS,
) as Array<[Patients.PatientGender, string]>;

export const PATIENT_MARITAL_STATUS_OPTIONS = Object.entries(
	PATIENT_MARITAL_STATUS_LABELS,
) as Array<[Patients.PatientMaritalStatus, string]>;

export const PATIENT_EDUCATION_LEVEL_OPTIONS = Object.entries(
	PATIENT_EDUCATION_LEVEL_LABELS,
) as Array<[Patients.PatientEducationLevel, string]>;
